// Matches a product's admin-typed printMethod free-text value against the
// set of real-world labels vendors/admins have used for sublimation, so the
// sublimation-preview module (services/sublimationPreviewService.ts) can
// recognize a design that should get the real dye-blended preview. Mirrors
// domingPreview.ts's own DOMING_METHOD_KEYWORDS matching convention exactly
// (see that file's comment for the full rationale on why a substring match,
// not an enum).
//
// Confirmed against real seeded ProductConfig.printMethods data (30+ rows,
// e.g. MO2202/MO2203/CX1466) and translationLookup.ts's own EN->NL mapping —
// unlike Doming (no separate Dutch term), Sublimation DOES have one:
// 'Sublimation' -> 'Sublimatie' (line ~160) and vendor code MPSU ->
// 'Sublimatie' (line ~78) — both real, both included below.
const SUBLIMATION_METHOD_KEYWORDS = ['sublimation', 'sublimatie'];

export function isSublimationPrintMethod(printMethod: string | null | undefined): boolean {
  if (!printMethod) return false;
  const lower = printMethod.toLowerCase();
  return SUBLIMATION_METHOD_KEYWORDS.some(kw => lower.includes(kw));
}

export const SUBLIMATION_PREVIEW_DESIGN_IMAGE_TYPE = 'sublimation_preview';

// Design.sublimationPreviewStatus int convention — mirrors
// DomingPreviewStatus (see schema.prisma's own comment on the column).
export const SublimationPreviewStatus = {
  NONE:       0,
  QUEUED:     1,
  PROCESSING: 2,
  DONE:       3,
  FAILED:     4,
} as const;
export type SublimationPreviewStatusValue = typeof SublimationPreviewStatus[keyof typeof SublimationPreviewStatus];
